const isLocalhost = require("../environment/isLocalhost");
const convertDemoFormDataToGoogleSheetFormData = require("./convertDemoFormDataToGoogleSheetFormData");

/**
 * @typedef {{
 *     'JSON Payload': string,
 *     Email: string,
 *     FirstName: string,
 *     LastName: string,
 *     Company: string,
 *     Company_Size_Range__c: string,
 *     Country: string,
 *     State: string,
 *     marketingConsent: string,
 *     URL: string,
 *     _mktoReferrer: string,
 *     formVid: string,
 *     munchkinId: string,
 *     _mkt_trk: string,
 *     HQ_Country__c: string,
 *     HQ_State__c: string,
 *     Marketing_Channels__c: string,
 *     Email_Sends_per_Month_Range__c: string,
 *     demoRequestNotesImport: string,
 *     demoRequestEmailProvider: string,
 *     Phone: string,
 *     Email_Verification_Status__c: string,
 *     kickboxReason: string,
 *     Locale__c: string,
 *     Primary_Use_Case__c: string,
 *     formid: string,
 *     LOG_TYPE: GoogleSheetsLogType,
 * }} GoogleSheetFormData
 */

/**
 * @param googleSheetFormData {GoogleSheetFormData}
 * @returns {Promise<void>}
 */
module.exports = async function submitFormToGoogleSheets(googleSheetFormData) {
    if (isLocalhost()) {
        return;
    }

    const formData = convertDemoFormDataToGoogleSheetFormData(googleSheetFormData);

    try {
        await fetch(
            "https://docs.google.com/forms/u/1/d/e/1FAIpQLSfvgAHZh1i5kIUdyx8wMZ589_4AIt6NVhswontovoogdaQTVQ/formResponse",
            {method: "POST", body: formData}
        );
    } catch (e) {
        // Failsafe
    }
}